import { useCallback } from 'react';
import { useApiBase } from '../../base/api-base';

export class ConfirmarRedefinirSenhaProps {
    public constructor(
        public telefone: string = '',
        public email: string = '',
        public cpfCnpj: string = '',
        public redefinirCodigo: string = '',
        public senha: string = '',
        public senhaConfirmacao: string = '',
    ) { }
}

export function usePostConfirmarRedefinirSenha() {
    const { invocarApi, ...outrasPropriedades } = useApiBase();

    const postConfirmarRedefinirSenha = useCallback(
        (confirmarProps: ConfirmarRedefinirSenhaProps) =>
            invocarApi({
                url: `/v4/Auth/confirmar-redefinir-senha`,
                method: 'POST',
                data: confirmarProps,
                enviarTokenUsuario: false
            }),
        [invocarApi],
    );
    return {
        ...outrasPropriedades,
        postConfirmarRedefinirSenha,
    };
}
